import moment from 'moment';

const CustomDatePicker = ({ value, onChange }) => {
  const handleChange = (e) => {
    const date = e.target.value;
    onChange(moment(date).add(12, 'hours')); // Add 12 hours to the date
  };

  return (
    <input
      type="date"
      value={value ? value.format('YYYY-MM-DD') : ''} // Format Moment object to string
      onChange={handleChange}
      className="ant-input"
      style={{
        width: '100%',
        padding: '4px 11px',
        fontSize: '14px',
        lineHeight: '1.5715',
        backgroundColor: '#fff',
        backgroundImage: 'none',
        border: '1px solid #d9d9d9',
        borderRadius: '2px',
        transition: 'all 0.3s',
      }}
    />
  );
};


export default CustomDatePicker;